import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import StepLabel from '@material-ui/core/StepLabel';
import DataUsage from '@material-ui/icons/DataUsage';
import Run from '@material-ui/icons/PlayArrow';
import Fade from '@material-ui/core/Fade';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Avatar from '@material-ui/core/Avatar';
import Phone from '@material-ui/icons/Phone';
import Mail from '@material-ui/icons/Mail';
import LinkedIn from '@material-ui/icons/LinkedIn';
import Language from '@material-ui/icons/Language';
import Tooltip from '@material-ui/core/Tooltip';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';
import { Email } from '@material-ui/icons';





//-----------------------------------------------------------------



const useStyles = (theme) => ({

    avatar: {
        width: 62,
        height: 62,
        marginLeft: 8,
    },    

    itemAvatar: {
        width: 78,
        height: 64,
        marginLeft: 24,
        marginTop: 36,
    },

    itemContact: {
        width: 310,
        height: 64,
        marginTop: 28,
    },

    itemBoxLeft: {
        width: 110,
    },

    itemBoxRight: {
        width: 280,
    },

    textSytleContact: {
        lineHeight: 1.4,
    },

    textSytleName: {
        marginBottom: 2,
        fontWeight: 600,
    },

    textSytleBoxLeft: {
        fontWeight: 600,
        lineHeight: 1.4,
    },

    textSytleBoxRight: {
        lineHeight: 1.4,
    },

    iconText: {
        width: 16,
        height: 16,
        marginRight: 8,
    },


});



//-----------------------------------------------------------------



class infoPopover_ extends Component {
    
  constructor(props) {
    super(props);
  }


  render() {

    const {classes} = this.props;
    
    return (

        <div>

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                style={{backgroundColor:'#FFFFFF'}}>


                <Grid item className={classes.itemAvatar}>

                    <Avatar src="./res/images/avatar_Natalia_Grozmani.png"  
                        className={classes.avatar} />

                </Grid>


                <div style={{height:64, width:0.5, marginTop:36, marginLeft:16, marginRight:24, backgroundColor:'#DADADA'}}/>


                <Grid item className={classes.itemContact}>
                    
                    <Typography variant="subtitle1" color="textPrimary" className={classes.textSytleName} >
                        Natalia Grozmani    
                        <IconButton href={'https://de.linkedin.com/in/natalia-grozmani-a437aa12a'} target="_blank" rel="noreferrer" style={{width:24, height:24, marginLeft:32}}>
                            <Tooltip title="Open LinkedIn profile">
                                <LinkedIn fontSize={'small'} color='secondary'/>
                            </Tooltip>
                        </IconButton>
                        <IconButton href={'https://www.wzl.rwth-aachen.de/go/id/siic/gguid/0xC90445FF1C27E14B8AA9C070296F3610'} target="_blank" rel="noreferrer" style={{width:24, height:24, marginLeft:12}}>
                            <Tooltip title="Open WZL profile">
                                <Language fontSize={'small'} color='secondary'/>
                            </Tooltip>
                        </IconButton>
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleContact} >
                        <Phone className={classes.iconText}/> 0241 80-25834
                    </Typography>

                    <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleContact} >
                        <Mail className={classes.iconText}/> N.Grozmani@wzl.rwth-aachen.de
                    </Typography>

                </Grid>


            </Grid>

            {/*<Grid*/}
            {/*    container*/}
            {/*    direction="row"*/}
            {/*    justifyContent="center"*/}
            {/*    alignItems="center">*/}


            {/*    <Grid item className={classes.itemAvatar}>*/}

            {/*        <Avatar src="./res/images/avatar_Alexander_Moriz.png" */}
            {/*            className={classes.avatar}/>*/}

            {/*    </Grid>*/}


            {/*    <div style={{height:64, width:0.5, marginTop:36, marginLeft:16, marginRight:24, backgroundColor:'#DADADA'}}/>*/}


            {/*    <Grid item className={classes.itemContact}>*/}

            {/*        <Typography variant="subtitle1" color="textPrimary" className={classes.textSytleName} >*/}
            {/*            Alexander Moriz    */}
            {/*            <IconButton href={'https://de.linkedin.com/in/alexander-moriz-5b941b163'} target="_blank" rel="noreferrer" style={{width:24, height:24, marginLeft:32}}>*/}
            {/*                <Tooltip title="Open LinkedIn profile">*/}
            {/*                    <LinkedIn fontSize={'small'} color='secondary'/>*/}
            {/*                </Tooltip>*/}
            {/*            </IconButton>*/}
            {/*            <IconButton href={'https://www.wzl.rwth-aachen.de/go/id/siic/gguid/0x50495BC2DBEC6E478AB50B49B91DB3FF'} target="_blank" rel="noreferrer" style={{width:24, height:24, marginLeft:12}}>*/}
            {/*                <Tooltip title="Open WZL profile">*/}
            {/*                    <Language fontSize={'small'} color='secondary'/>*/}
            {/*                </Tooltip>*/}
            {/*            </IconButton>*/}
            {/*        </Typography>*/}

            {/*        <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleContact} >*/}
            {/*            <Phone className={classes.iconText}/> 0241 80-20602*/}
            {/*        </Typography>*/}

            {/*        <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleContact} >*/}
            {/*            <Mail className={classes.iconText}/> A.Moriz@wzl.rwth-aachen.de*/}
            {/*        </Typography>*/}

            {/*    </Grid>*/}


            {/*</Grid>*/}


            <Box style={{backgroundColor:'#F4F4F9'}}>

                <div style={{width:452, height:1, marginTop: 32, backgroundColor:'#DCDCDC'}} />
            
                <Grid
                    container
                    direction="row"
                    style={{marginLeft: 20, marginRight: 20, marginTop: 20, marginBottom: 16}}>


                    <Grid item className={classes.itemBoxLeft}>

                        <Typography variant="subtitle2" color="textPrimary" className={classes.textSytleBoxLeft} >
                            Development
                        </Typography>

                    </Grid>


                    <Grid item className={classes.itemBoxRight}>
                        
                        <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleBoxRight} >
                            Mostafa Zaghloul
                        </Typography>

                        <Typography variant="subtitle2" color="textSecondary" className={classes.textSytleContact} >
                            <Mail className={classes.iconText}/>m.zaghloul@wzl.rwth-aachen.de
                        </Typography>

                    </Grid>


                </Grid>

                <Grid
                    container
                    direction="row"
                    style={{marginLeft: 20, marginRight: 20, marginBottom: 20}}>


                    <Grid item className={classes.itemBoxLeft}>

                        <Typography variant="subtitle2" color="textPrimary" className={classes.textSytleBoxLeft} style={{whiteSpace: 'pre-line'}} >
                            Team{"\n"}Dashboard
                        </Typography>

                    </Grid>


                    <Grid item className={classes.itemBoxRight}>
                    

                        <a href="https://multispectralctsimulation.dashboards.vfk.ipt.fraunhofer.de/" target="_blank" rel="noreferrer">
                            <Typography variant="subtitle2" color="secondary" className={classes.textSytleBoxRight} >
                                High-precision simulation for automatic parametrization of multi-spectral CT
                            </Typography>
                        </a>

                    </Grid>


                </Grid>

                <div style={{width: 1, height: 1}}/>

            </Box>


        </div>

    );

  }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
    };
  
}


const infoPopover = connect(mapStateToProps, mapDispatchToProps)(infoPopover_)
export default withStyles(useStyles) (infoPopover);
